export default (maxLength) => ({
    init () {
        const element = this.$el.querySelector('input[type=number]');

        element.addEventListener('keydown', function () {
            if (element.value.length >= maxLength) {
                element.value = element.value.slice(0, maxLength);
            }
        });

        element.addEventListener('keyup', function () {
            if (element.value.length >= maxLength) {
                element.value = element.value.slice(0, maxLength);
            }
        });

        this.$nextTick(() => {
            const wireUiEl = this.$el.querySelector('[x-data]');
            
            if (wireUiEl && window.Alpine) {
                const data = window.Alpine.$data(wireUiEl);
                if (data && data.value !== undefined) {
                    data.value = element.value;
                }
            }
        });
    }
});
